// extracted by mini-css-extract-plugin
export var basicSubformButton = "FormSummary-module__basicSubformButton___QGEUg";
export var editButton = "FormSummary-module__editButton___AaA+O";
export var subFormMetadata = "FormSummary-module__subFormMetadata___k0Fw+";
export var subFormRightSideCol = "FormSummary-module__subFormRightSideCol___n8O7w";
export var subFormTitle = "FormSummary-module__subFormTitle___B9Igd";
export var xboxGreen = "#107C10";